/**
 * palette contains the basic colors set
 */
export const palette = {
    primary: '#5F98D0',
    secondary: '#F9FAFB',
    gray_700: '#344054',
    white: '#FFFFFF',
    white_F5F5F5: '#F5F5F5',
    white_F7F7F7: '#F7F7F7',
    gray_535354: '#535354',
    gray_545454: '#545454',
    gray_646464: '#646464',
    gray_200: '#E4E7EC',
    gray_788899: '#788899',
    icon_gray: '#4D6277',
    gray_B8B8B8: '#B8B8B8',
    gray_25: '#FCFCFD',
    gray_7A7979: '#7A7979',
    gray_E8E8E8: '#E8E8E8',
    gray_EAEAEA: '#EAEAEA',
    gray_CCC: '#CCC',
    gray_F2F2F2: '#F2F2F2',
    gray_FDFCFC: '#FDFCFC',
    gray_EDEDED: '#EDEDED',
    gray_FBFBFB: '#FBFBFB',
    gray_F5F6F6: '#F5F6F6',
    gray_A1A1A1: '#A1A1A1',
    gray_F0F2F7: '#F0F2F7',
    gray_333: '#333333',
    gray_EFEFEF: '#EFEFEF',
    gray_9DA1A7: '#9DA1A7',
    green_80D965: '#80D965',
    black: '#000000',
    black_transparent: 'rgba(0,0,0,0.4)',
};

export const color = {
    ...palette,
};
